module.exports = __webpack_public_path__ + "static/img/fontello.2382f1e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.svg?26533562
// module id = 545
// module chunks = 1